"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTargetOrigin = void 0;
const isWindowAvailable_1 = require("./isWindowAvailable");
const getTargetOrigin = () => {
    var _a;
    if ((0, isWindowAvailable_1.isWindowAvailable)()) {
        const ancestorOrigins = window.location.ancestorOrigins;
        return (_a = ancestorOrigins === null || ancestorOrigins === void 0 ? void 0 : ancestorOrigins[ancestorOrigins.length - 1]) !== null && _a !== void 0 ? _a : '*';
    }
    return '*';
};
exports.getTargetOrigin = getTargetOrigin;
//# sourceMappingURL=getTargetOrigin.js.map